module.exports = __webpack_public_path__ + "static/media/Madfit-4.3aca686c.jpg";